"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsPlan = void 0;
const Plan_1 = require("../../Domain/Plan");
const features_1 = require("../../features");
const limits_1 = require("../../limits");
exports.TeamsPlan = Plan_1.Plan.create(features_1.CademyFeatures, limits_1.CademyLimits, {
    id: '01J676K6ZVJRV5YEK8JB4X0NE8',
    name: 'Teams',
    visible: true,
    pricing: {
        GBP: {
            monthly: 599,
            yearly: 5988,
        },
        USD: {
            monthly: 779,
            yearly: 7788,
        },
        EUR: {
            monthly: 779,
            yearly: 7788,
        },
    },
    features: {
        general: {
            customCertificates: true,
            scorm: true,
            privateDates: true,
            noteAttachments: true,
            importCourses: true,
        },
        marketplace: {
            hideProfile: true,
            hideCourses: true,
        },
        analytics: {
            monthlyAnalyticsEmails: true,
        },
        branding: {
            addYourBranding: true,
            customBrandColour: true,
            whitelabelling: true,
            customEmailDomain: true,
        },
        privacyAndSecurity: {
            restrictMinisite: false,
            sso: false,
            privateCourses: true,
        },
        payments: {
            invoiceCheckouts: true,
            manualPayments: true,
        },
        apps: {
            zapier: true,
        },
        ai: {
            courseGeneration: true,
        },
    },
    limits: {
        numberOfAdmins: {
            period: null,
            value: 20,
            kind: 'hard',
        },
        numberOfCourseInvites: {
            kind: 'hard',
            period: null,
            value: 'infinite',
        },
        numberOfImportedBookings: {
            kind: 'hard',
            period: null,
            value: 1000,
        },
        numberOfImportedOrders: {
            kind: 'hard',
            period: null,
            value: 1000,
        },
        numberOfPublishedCourses: {
            kind: 'hard',
            period: null,
            value: 'infinite',
        },
        maxFileUploadSize: {
            kind: 'hard',
            period: null,
            value: 102400,
        },
        maxAgeOfForumPosts: {
            kind: 'hard',
            period: null,
            value: 'infinite',
        },
        aiCredits: {
            kind: 'hard',
            period: 'monthly',
            value: 500,
        },
    },
});
